function toTheTopInit() {
	var toTheTop = $(".js-to-the-top");
	var windowHeight = $(window).height();
	toTheTop.hide();

	$(window).on("scroll", function() {
		if ($(this).scrollTop() > windowHeight) {
			toTheTop.fadeIn();
		} else {
			toTheTop.fadeOut();
		}
	});

	toTheTop.on("click", function(e) {
		$("html, body").animate({ scrollTop: 0 }, 500);
	});
}